

































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import type { SorteioSelecionadoForm } from '@/models'
import { formatarMoeda } from '@/shareds/formatadores'

@Component
export default class DialogoDeSorteioSelecionado extends Vue {
	@Prop({ required: true }) sorteioSelecionado!: SorteioSelecionadoForm

	mostra = false
	confirmando = false
	private resolverConfirmacao: ((confirmado: boolean) => void) | null = null
	formatarMoeda = formatarMoeda

	mostrar() {
		this.mostra = true
	}

	async mostrarEEsperarConfirmacao(): Promise<boolean> {
		this.mostrar()
		return await new Promise(resolve => {
			this.resolverConfirmacao = resolve
		})
	}

	fechar() {
		this.mostra = false
		if (this.resolverConfirmacao) {
			this.resolverConfirmacao(false)
			this.resolverConfirmacao = null
		}
	}

	confirmar() {
		this.confirmando = true
		this.mostra = false

		if (this.resolverConfirmacao) {
			this.resolverConfirmacao(true)
			this.resolverConfirmacao = null
		}

		this.confirmando = false
	}
}

